import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';
import { useForm, useField } from 'react-final-form';
import strings from 'localization/strings';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(({ theme }) => ({
    quantitySelectorContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'center'
    },
}));

const QuantitySelector = ({ name, onChange }) => {
    const classes = useStyles();
    const form = useForm();
    const value = useField(name).input.value;

    const handleChange = delta => {
        form.change(name, value + delta);
        onChange(value + delta, value);
    };

    return (
        <Box className={classes.quantitySelectorContainer}>
            {
                value > 0 &&
                (
                    <>
                        <Button
                            size="small"
                            color="primary"
                            variant="outlined"
                            onClick={() => handleChange(-1)}
                        >
                            {strings.remove}
                        </Button>
                        <Box>
                            {value}
                        </Box>
                    </>
                )
            }
            <Button
                size="small"
                color="primary"
                variant="outlined"
                onClick={() => handleChange(1)}
            >
                {strings.add}
            </Button>
        </Box>
    );
};

QuantitySelector.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export default QuantitySelector;
